import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";



const firebaseConfig = {
	apiKey: "AIzaSyDQ_RTdLtETOfuelY94R58FjmxZzkJxurE",
	authDomain: "joe-linkedin.firebaseapp.com",
	projectId: "joe-linkedin",
	storageBucket: "joe-linkedin.appspot.com",
	messagingSenderId: "811273299914",
	appId: "1:811273299914:web:918f7b3a33c0c7c86c5133"
  };
// Initializing firebase
const app = firebase.initializeApp(firebaseConfig);
// Connecting to db
const db = firebase.firestore();
//Connecting Auth
const auth = firebase.auth();

export { app, db, auth };
